import React from 'react'
import moment from 'moment'
import {
  Col,
  DetailList,
  Row
} from 'camino-react'

import StringManipulator from 'Utilities/StringManipulator'
import BooleanPillSkeleton from 'Components/Skeletons/BooleanPillSkeleton'

const ViewableFormFields = ({
  start_time,
  end_time,
  duration_minutes,
  duration_minutes_with_deducted,
  description,
  comments,
  chargeable,
  workType,
  workRole,
  work_type_name,
  work_role_name,
  utilizationDeductableMinutes,
  allTimesheetsView,
  invoiceId,
  paths
}) => (
    <>
      <Row smallGutters>
        <Col width={6}>
          <DetailList
            list={[
              {
                title: 'Start Time',
                content: `${moment(start_time).format('DD MMM YYYY, HH:mma')}`
              }
            ]}
          />
          <DetailList
            list={[
              {
                title: 'End Time',
                content: `${moment(end_time).format('DD MMM YYYY, HH:mma')}`
              }
            ]}
          />
          <DetailList
            list={[
              {
                title: 'Chargeable?',
                content: <BooleanPillSkeleton
                  boolean={chargeable}
                />
              }
            ]}
          />
          <DetailList
            list={[
              {
                title: 'Work Type',
                content: `${workType || work_type_name}`
              }
            ]}
          />
        </Col>
        <Col width={6}>
          <DetailList
            list={[
              {
                title: 'Total Time',
                content: `${duration_minutes} min`
              }
            ]}
          />
          {duration_minutes !== duration_minutes_with_deducted && (
            <DetailList
              list={[
                {
                  title: 'Total Time (With Deducted)',
                  content: `${duration_minutes_with_deducted} min`
                }
              ]}
            />
          )}
          <DetailList
            list={[
              {
                title: 'Utilization deductable minutes',
                content: utilizationDeductableMinutes
              }
            ]}
          />
          <DetailList
            list={[
              {
                title: 'Work Role',
                content: `${workRole || work_role_name}`
              }
            ]}
          />
        </Col>
        <Col width={12}>
          <DetailList
            list={[
              {
                title: 'Description',
                content: description
              }
            ]}
          />
          {comments && (
            <DetailList
              list={[
                {
                  title: 'Internal comments',
                  content: StringManipulator.simpleFormat(comments)
                }
              ]}
            />
          )}
          {invoiceId && (
            <DetailList
              list={[
                {
                  title: 'Invoice ID',
                  content: <a href={paths.invoicePath} target="_blank" rel="noopener noreferrer">{`CAL${invoiceId}`}</a>
                }
              ]}
            />
          )}
        </Col>
      </Row>
      {allTimesheetsView && (
        <Row>
          <hr />
        </Row>
      )}
    </>
)

ViewableFormFields.defaultProps = {
  allTimesheetsView: false
}

export default ViewableFormFields
